module.exports = __webpack_public_path__ + "static/media/smartcoach_logo.64c1b20a.webp";